<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M6.5 21A1.5 1.5 0 008 19.5V8h11.5a1.5 1.5 0 000-3H7a2 2 0 00-2 2v12.5A1.5 1.5 0 006.5 21zM57 5H44.5a1.5 1.5 0 000 3H56v11.5a1.5 1.5 0 003 0V7a2 2 0 00-2-2zM19.5 56H8V44.5a1.5 1.5 0 00-3 0V57a2 2 0 002 2h12.5a1.5 1.5 0 000-3zM57.5 43a1.5 1.5 0 00-1.5 1.5V56H44.5a1.5 1.5 0 000 3H57a2 2 0 002-2V44.5a1.5 1.5 0 00-1.5-1.5zM14.5 16.5v31a2 2 0 002 2h31a2 2 0 002-2v-31a2 2 0 00-2-2h-31a2 2 0 00-2 2zm3 1h29v29h-29z"/></svg>